import React, { useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GlobalContext from '../../../main/utils/GlobalContext';

const ClassroomBlockList = ({ classroomId }) => {
  const { locales } = useContext(GlobalContext);
  const {
    blocks: { data },
  } = useSelector((state) => state);

  const {
    blocks: { fetchBlock },
  } = useDispatch();

  useEffect(() => {
    if (classroomId) {
      fetchBlock({
        by: 'classrooms',
        byId: classroomId,
        pageName: 'classroom',
      });
    }
  }, [classroomId]);

  return (
    <div className="classroom-block-list">
      <div className="classroom-block-list__row">
        <div className="classroom-block classroom-block__fg3">
          <div className="classroom-block__header">
            {locales.admin.students}
          </div>
          <div className="classroom-block__items">
            <div className="classroom-block__item">
              <div className="classroom-block__value">{data.totalProject}</div>
              <div className="classroom-block__title">
                {locales.admin.totalProjects}
              </div>
            </div>
            <div className="classroom-block__item">
              <div className="classroom-block__value">{data.totalStudents}</div>
              <div className="classroom-block__title">
                {locales.admin.totalStudents}
              </div>
            </div>
            <div className="classroom-block__item">
              <div className="classroom-block__value">
                {data.totalLastActiveStudents}
              </div>
              <div className="classroom-block__title">
                {locales.admin.activeLast30Days}
              </div>
            </div>
          </div>
        </div>
        <div className="classroom-block classroom-block__fg3">
          <div className="classroom-block__header">
            {locales.admin.totalProgress}
          </div>
          <div className="classroom-block__items">
            <div className="classroom-block__item">
              <div className="classroom-block__value">{data.ideasCount}</div>
              <div className="classroom-block__title">
                {locales.admin.ideasCreated}
              </div>
            </div>
            <div className="classroom-block__item">
              <div className="classroom-block__value">
                {data.canvasProgress}
              </div>
              <div className="classroom-block__title">
                {locales.admin.canvasProgress}
              </div>
            </div>
            <div className="classroom-block__item">
              <div className="classroom-block__value">
                {data.testsCompleted}
              </div>
              <div className="classroom-block__title">
                {locales.admin.testsCompleted}
              </div>
            </div>
          </div>
        </div>
        <div className="classroom-block classroom-block__fg2">
          <div className="classroom-block__header">
            {locales.admin.activity}
          </div>
          <div className="classroom-block__items">
            <div className="classroom-block__item">
              <div className="classroom-block__value">
                {data.totalSiteTimeTracks}
              </div>
              <div className="classroom-block__title">
                {locales.admin.totalMinutes}
              </div>
            </div>
            <div className="classroom-block__item">
              <div className="classroom-block__value">
                {data.totalSiteLastTotalTracks}
              </div>
              <div className="classroom-block__title">
                {locales.admin.minutesLast30Days}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassroomBlockList;
